import Axios from "axios";

const state = () => ({
  version: null,
  info: {},
  code: null,
  message: null,
  status: null,
  loading: false,
  host: process.env.VUE_APP_API_HOST || 'http://localhost:8020',
});

const mutations = {
  set_version(state, version){
    state.version = version
  },
  set_info(state, info){
    state.info = info
  },
  set_code(state, code){
    state.code = code
  },
  set_message(state, message){
    state.message = message
  },
  set_status(state, status){
    state.status = status
  },
  set_loading(state, loading){
    state.loading = loading
  }
};

const actions = {
  manageVersion({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let url = state.host+"/api/tool/app-version/manage";
      const headers = { Authorization: "Bearer " + localStorage.getItem("token") };

      const data_version = {
          "platform": payload.platform,
          "latestVersion": payload.latestVersion,
          "minimumVersion": payload.minimumVersion,
          "forceUpdate": payload.forceUpdate,
          "message": payload.message,
          "downloadUrl": payload.downloadUrl,
          "active": payload.active,
          "releaseNotes": payload.releaseNotes
      }
      
      Axios.post(url, data_version, { headers: headers })
        .then((response) => {
          const data_version = response.data;

          commit("set_version", data_version.version);
          commit("set_info", data_version.info);
          commit("set_code", response.status);
          commit("set_message", "Version managed successfully");
          commit("set_status", "success");
          commit("set_loading", false);
          
          resolve(data_version);
        })
        .catch((error) => {
          commit("set_code", error.response ? error.response.status : 500);
          commit("set_message", error.message);
          commit("set_status", "error");
          commit("set_loading", false);
          
          reject(error);
        });
    });
  },
  fetchVersion({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let url = state.host+"/api/tool/app-version/all";
      const headers = { Authorization: "Bearer " + localStorage.getItem("token") };
      
      Axios.get(url, { headers: headers })
        .then((response) => {
          const data_version = response.data;

          commit("set_version", data_version.version);
          commit("set_info", data_version.info);
          commit("set_code", response.status);
          commit("set_message", "Version fetched successfully");
          commit("set_status", "success");
          commit("set_loading", false);
          
          resolve(data_version);
        })
        .catch((error) => {
          commit("set_code", error.response ? error.response.status : 500);
          commit("set_message", error.message);
          commit("set_status", "error");
          commit("set_loading", false);
          
          reject(error);
        });
    });
  },
  fetchVersionPlatform({ commit, state }, platform = 'ANDROID') {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let url = state.host+`/api/tool/app-version/platform/${platform}`;
      const headers = { Authorization: "Bearer " + localStorage.getItem("token") };
      
      Axios.get(url, { headers: headers })
        .then((response) => {
          const data_version = response.data;

          commit("set_version", data_version.version);
          commit("set_info", data_version.info);
          commit("set_code", response.status);
          commit("set_message", `Version for ${platform} fetched successfully`);
          commit("set_status", "success");
          commit("set_loading", false);
          
          resolve(data_version);
        })
        .catch((error) => {
          commit("set_code", error.response ? error.response.status : 500);
          commit("set_message", error.message);
          commit("set_status", "error");
          commit("set_loading", false);
          
          reject(error);
        });
    });
  },
  checkVersion({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let url = state.host+'/api/tool/app-version/check';
      const headers = { Authorization: "Bearer " + localStorage.getItem("token") };
      
      Axios.post(url, payload, { headers: headers })
        .then((response) => {
          const data_version = response.data;

          commit("set_version", data_version.version);
          commit("set_info", data_version.info);
          commit("set_code", response.status);
          commit("set_message", "Version checked successfully");
          commit("set_status", "success");
          commit("set_loading", false);
          
          resolve(data_version);
        })
        .catch((error) => {
          commit("set_code", error.response ? error.response.status : 500);
          commit("set_message", error.message);
          commit("set_status", "error");
          commit("set_loading", false);
          
          reject(error);
        });
    });
  },
  deleteVersion({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let url = state.host+'/api/tool/app-version/'+payload.id;
      const headers = { Authorization: "Bearer " + localStorage.getItem("token") };
      
      Axios.delete(url, { headers: headers })
        .then((response) => {
          const data_version = response.data;

          commit("set_version", data_version.version);
          commit("set_info", data_version.info);
          commit("set_code", response.status);
          commit("set_message", "Version checked successfully");
          commit("set_status", "success");
          commit("set_loading", false);
          
          resolve(data_version);
        })
        .catch((error) => {
          commit("set_code", error.response ? error.response.status : 500);
          commit("set_message", error.message);
          commit("set_status", "error");
          commit("set_loading", false);
          
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};